import React, { useEffect, useState } from "react";

const SECRET_CODE = "WeseleKB2026";

function AccessGuard({ children }) {
    const [allowed, setAllowed] = useState(false);
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        // Sprawdź czy już ma dostęp z tej sesji
        if (localStorage.getItem("wesele_access") === "granted") {
            setAllowed(true);
            setChecking(false);
            return;
        }

        // Pobierz wszystko po "?kod=" z URL
        const search = window.location.search;
        const kodIndex = search.indexOf("kod=");

        if (kodIndex !== -1) {
            const rawKod = search.substring(kodIndex + 4);
            // Dekoduj URL encoding
            const decoded = decodeURIComponent(rawKod);
            // Usuń wszystko po ewentualnym & (inne parametry)
            const kod = decoded.split("&")[0];

            console.log("Wpisany kod:", kod);
            console.log("Oczekiwany:", SECRET_CODE);

            if (kod === SECRET_CODE) {
                localStorage.setItem("wesele_access", "granted");
                setAllowed(true);
                setChecking(false);
                return;
            }
        }

        setAllowed(false);
        setChecking(false);
    }, []);

    if (checking) {
        return (
            <div className="access-loading">
                <div className="access-spinner">🍋</div>
            </div>
        );
    }

    if (!allowed) {
        return (
            <div className="access-blocked">
                <div className="access-blocked-inner">
                    <div className="access-icon">💍</div>
                    <h1 className="access-title">
                        Klaudia<br />
                        <span className="access-amp">&</span><br />
                        Bartłomiej
                    </h1>
                    <p className="access-date">15 · 08 · 2026</p>
                    <div className="access-divider"></div>
                    <p className="access-msg">
                        Ta strona jest dostępna<br />
                        tylko dla zaproszonych gości
                    </p>
                    <p className="access-sub">
                        Zeskanuj kod QR z zaproszenia<br />
                        aby uzyskać dostęp
                    </p>
                    <div className="access-qr-hint">
                        🔲 Zeskanuj QR kod
                    </div>
                </div>
            </div>
        );
    }

    return children;
}

export default AccessGuard;